// extracted by mini-css-extract-plugin
export default {"heading":"Kh-z","list":"Lh-z"};